export default {
    setRouterName: ({commit}, param) => commit('SET_ROUTER_NAME', param)
}




// WEBPACK FOOTER //
// ./src/store/navigation/action.js